import { SimpleIconList } from "@components"
import { CheckCircleIcon } from "@heroicons/react/24/solid"
import PropTypes from "prop-types"

const PresendSummary = ({ counts, notificationType }) => {
  const getNotificationType = () => {
    switch (notificationType.code) {
      case "BOOKING_CONFIRMATION_EMAIL":
        return "Booking Confirmation Email"
      case "CUSTOM_EMAIL":
        return "Custom Email"
      case "APP":
        return "In App Message"
      default: 
        return "Unknown Notification Type" 
    }
  }

  return (
    <div>
      <SimpleIconList
        iconSize="lg"
        items={[
          { icon: <CheckCircleIcon className="text-green-500" />, caption: `Notification type: ${getNotificationType()}` },
          { icon: <CheckCircleIcon className="text-green-500" />, caption: `Total guardians selected from the above category: ${counts.selected} of ${counts.total}` },
          { icon: <CheckCircleIcon className="text-green-500" />, caption: `Total emails to send: ${counts.selected}` },
        ]}
      />    
    </div>
  )
}

PresendSummary.propTypes = {
  counts: PropTypes.shape({
    deselected: PropTypes.number.isRequired,
    selected: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,

  notificationType: PropTypes.object,
}

export default PresendSummary